import React, { useState, useEffect, useCallback } from "react";
import "./EpisodeList.css";
import EpisodeListFilter from "./EpisodeListFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  selectedEpisodeList,
  getFilterEpisodeLists,
  getEpisodeFilterOptions,
  setEpisodeListFilterObj,
} from "./redux/EpisodeListSlicer";
import { useNavigate, useLocation } from "react-router-dom";
import { Table, Badge, Spinner, Form, Pagination } from "react-bootstrap";
import { Tooltip, Box, Drawer } from "@mui/material";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import RefershIcon from "../../../common/assets/images/reload.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  resetDocumentViewerError,
  resetEpisodeIdentifierTopassDocumentViewer,
  resetDocumentViewerLoadedData,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import {
  faSortAmountUp,
  faSortAmountDesc,
} from "@fortawesome/free-solid-svg-icons";
import { debounce } from "lodash";
import { MdHeight } from "react-icons/md";
import UploadFileIcon from "@mui/icons-material/UploadFile";
const EpisodeListMobile = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const permissionList = Object.keys(permissions);

  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const {
    episodesFilterList,
    episodesFilterListLoading,
    episodesFilterListError,
  } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const navigate = useNavigate();
  const currentLocation = useLocation(); // <- use a unique name

  const [episodeListRowsPerPage, setEpisodeListRowsPerPage] = useState(10);
  const [episodeListCurrentPage, setEpisodeListCurrentPage] = useState(1);
  const [showepisodeListFilter, setShowepisodeListFilter] = useState(false);
  const [open, setOpen] = useState(false);
  const totalPages =
    typeof episodesFilterList?.total_episodes === "number" &&
    typeof episodeListFilterObj?.page_size === "number" &&
    episodeListFilterObj.page_size > 0
      ? Math.ceil(
          episodesFilterList.total_episodes / episodeListFilterObj.page_size
        )
      : 0;

  // const indexOfLastEpisode  =  episodeListFilterObj.page * episodeListFilterObj.page_size;
  // const indexOfFirstEpisode =  indexOfLastEpisode - episodeListFilterObj.page_size;
  // const currentEpisodesList =  episodesFilterList?.episode?.slice(0, indexOfFirstEpisode) || [];
  // console.log(episodeListFilterObj.page * episodeListFilterObj.page_size, 'episodeListFilterObj.page')
  const dataToDisplay =
    episodesFilterList?.episode?.length > 0 && episodesFilterList?.episode;
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...episodeListFilterObj,
        page: pageNumber,
      };
      dispatch(setEpisodeListFilterObj(payload));
      dispatch(getFilterEpisodeLists(payload));
      // setEpisodeListCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("trackHistory", JSON.stringify([]));
    sessionStorage.setItem("redoStack", JSON.stringify([]));
    dispatch(getFilterEpisodeLists(episodeListFilterObj));
  }, []);

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...episodeListFilterObj,
      page: 1,
      page_size: Number(event.target.value),
    };

    dispatch(setEpisodeListFilterObj(payload));
    dispatch(getFilterEpisodeLists(payload));

    // setEpisodeListRowsPerPage(Number(event.target.value));
    // setEpisodeListCurrentPage(1);
  };

  const sortingEpisodeHandler = (name) => {
    const currentSortBy = episodeListFilterObj.sort_by;
    const currentSortOrder = episodeListFilterObj.sort_order;

    const newSortOrder =
      currentSortBy === name && currentSortOrder === "asc" ? "desc" : "asc";

    const payload = {
      ...episodeListFilterObj,
      sort_by: name,
      sort_order: newSortOrder,
    };

    dispatch(setEpisodeListFilterObj(payload));
    dispatch(getFilterEpisodeLists(payload));
  };

  const closeEpisodeFilterModal = () => {
    setShowepisodeListFilter(false);
  };
  const toggleDrawer = (state) => () => {
    console.log("entered toggle");
    setOpen(state);
    if (state === true) {
      dispatch(getEpisodeFilterOptions());
    }
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

    const debounceSearchHandler = useCallback(
        debounce((payload) => {
          dispatch(getFilterEpisodeLists(payload))
        }, 1000),
        []
      );
  
    const handleEpisodeIdentiferSearch = (e) => {
      const payload = {
        ...episodeListFilterObj,
        episode_identifier:
          e?.target?.value?.length > 0 ? e?.target?.value : "",
      };
      dispatch(setEpisodeListFilterObj(payload))
      debounceSearchHandler(payload);
    }


  return (
    <div className="episodelist-section" style={{ height: "50%" }}>
      <div className="episodelist-header">
        <div className="episodelist-header-section">
          <h4 className="episodelist-header-text">Episode List</h4>
          <span className="episodelist-header-text-total">{`(${
            episodesFilterList?.total_episodes
              ? episodesFilterList?.total_episodes
              : 0
          })`}</span>
        </div>
        <div className="episodelist-filter-section">
          <Box sx={{mr: 1}}>
                      <input className="episodelist-filter-episode-identifier" placeholder="Search episode identifer"
                              value={episodeListFilterObj?.episode_identifier}
                       onChange={handleEpisodeIdentiferSearch} />
                    </Box>
          {/* {permissionList?.includes("admin") &&
            (permissionList?.includes("Code Accelerate") ||
              permissionList?.includes("Code Assist")) && (
              <Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#4999C9",
                    mr: 1,
                    borderRadius: "10px",
                    fontSize: "12px",
                    display: " flex",
                    alignItems: "center",
                  }}
                  onClick={() => navigate("/upload-document")}
                >
                  Upload your own documents
                  <UploadFileIcon style={{ height: "15px" }} />
                </Button>
              </Button>
            )} */}
          {/* <Button variant="contained" sx={{backgroundColor: "#4999C9", mr:1, borderRadius: '10px', fontSize: "12px", display:" flex", alignItems: 'center'}} onClick={() => navigate("/upload-document")}>
                                            Upload your own documents
                                            <UploadFileIcon  />
                                           </Button> */}
                                           
          <span
            class="episodelist-refresh-btn"
            onClick={() => window.location.reload()}
          >
            {/* <span> */}
              <img src={RefershIcon} alt="img" />
            {/* </span> */}
          </span>
          {/* <button
  className="episodelist-filter-btn"
  onClick={toggleDrawer(true)} // ✅ Correct
>
  Filters
</button> */}
          <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
            {DrawerList}
          </Drawer>
          <button
            className="episodelist-filter-btn"
            onClick={() => {
              setShowepisodeListFilter(!showepisodeListFilter);
              dispatch(getEpisodeFilterOptions());
            }}
          >
            Filters
          </button>
        </div>
      </div>
      <div
        className="episodelist-table-container"
        style={{ overflowX: "auto" }}
      >
        <Table
          // responsive="sm"
          style={{ textAlign: "center" }}
          className={`${
            episodesFilterList?.episode?.length <= 0 ||
            episodesFilterList?.episode?.length === undefined ||
            episodesFilterListLoading ||
            episodesFilterListError
              ? "episodelist-filter-table-loading"
              : "episodelist-filter-table"
          }`}
        >
          <thead className="episodelist-thead">
            <tr className="episodelist-tr">
              <th
                className="episodelist-th"
                style={{ position: "sticky", left: 0, zIndex: 50 }}
              >
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("medical_record_number")}
                >
                  <div>
                    <span>UR Number</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "medical_record_number" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by ===
                        "medical_record_number" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("episode_identifier")}
                >
                  <div>
                    <span> Episode Number</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "episode_identifier" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "episode_identifier" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("admission_date")}
                >
                  <div>
                    <span>Admission Date</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "admission_date" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "admission_date" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("separation_date")}
                >
                  <div>
                    <span>Discharge Date</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "separation_date" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "separation_date" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("length_of_stay")}
                >
                  <div>
                    <span>LOS</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "length_of_stay" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "length_of_stay" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("speciality")}
                >
                  <div>
                    <span>Speciality</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "speciality" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "speciality" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              {/* <th className="episodelist-th">
                <div className="episodelist-th-container" onClick={() => sortingEpisodeHandler("created_at")}>
                  <div>
                    <span>Created At</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "created_at" && episodeListFilterObj.sort_order === "asc" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountUp}  /></span>
                    ) : episodeListFilterObj.sort_by === "created_at" && episodeListFilterObj.sort_order === "desc" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountDesc}  /></span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountUp}  /></span>
                    ) : <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountDesc}  /></span>
                    }
                  </div>
                </div>
              </th> */}

              <th className="episodelist-th" style={{ minWidth: "100px" }}>
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("drg")}
                >
                  <div>
                    <span>Drg</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "drg" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "drg" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th" style={{ minWidth: "200px" }}>
                <div
                  className="episodelist-th-container-status"
                  onClick={() => sortingEpisodeHandler("status")}
                >
                  <div>
                    <span>Status</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "status" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "status" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              {location.pathname != "/Code-Assist-Episode-list" && (
                <th className="episodelist-th">
                  <div
                    className="episodelist-th-container"
                    onClick={() => sortingEpisodeHandler("no_of_documents")}
                  >
                    <div>
                      <span>No of documents</span>
                    </div>
                    <div>
                      {episodeListFilterObj.sort_by === "no_of_documents" &&
                      episodeListFilterObj.sort_order === "asc" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountUp} />
                        </span>
                      ) : episodeListFilterObj.sort_by === "no_of_documents" &&
                        episodeListFilterObj.sort_order === "desc" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountDesc} />
                        </span>
                      ) : episodeListFilterObj.sort_by === "" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountUp} />
                        </span>
                      ) : (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountDesc} />
                        </span>
                      )}
                    </div>
                  </div>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {episodesFilterListLoading ? (
              <td colspan="10">
                <div className="episodelist-table-loader">
                  <Spinner />{" "}
                </div>
              </td>
            ) : episodesFilterListError ? (
              <td colspan="10">
                <div className="episodelist-table-loader">
                  Something went wrong
                </div>
              </td>
            ) : dataToDisplay?.length > 0 ? (
              dataToDisplay?.map((episode) => {
                return (
                  <tr
                    key={episode.episode_number}
                    onDoubleClick={() => {
                      // navigate("/coder");
                      const currentPath = currentLocation.pathname;
                      const destinationPath =
                        currentPath === "/Code-Assist-Episode-list"
                          ? "/Code-Assist"
                          : "/coder";

                      navigate(destinationPath);
                      dispatch(resetEpisodeIdentifierTopassDocumentViewer());
                      localStorage.setItem("currentPage", "episodeList");
                      localStorage.setItem(
                        "filters",
                        JSON.stringify(episodeListFilterObj)
                      );
                      dispatch(resetDocumentViewerLoadedData());
                      dispatch(selectedEpisodeList(episode));
                      dispatch(resetDocumentViewerError());
                    }}
                  >
                    <td
                      className="episodelist-td"
                      style={{ position: "sticky", left: 0 }}
                    >
                      <Tooltip title={episode.medical_record_number}>
                        {episode.medical_record_number
                          ? episode.medical_record_number
                          : "-"}
                      </Tooltip>
                    </td>
                    <td className="episodelist-td">
                      {episode.episode_identifier
                        ? episode.episode_identifier
                        : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.admission_date ? episode.admission_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.separation_date ? episode.separation_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.length_of_stay ? episode.length_of_stay : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.speciality ? episode.speciality : "-"}
                    </td>
                    {/* <td className="episodelist-td">
                      {episode.created_at ? episode.created_at : "-"}
                    </td> */}
                    <td
                      className={`episodelist-td ${
                        episode.status === "Coding Complete" ||
                        episode.status === "aCS Coding Complete"
                          ? "episodelist-td-min-bold-drg"
                          : episode.status ===
                              "AI processing complete - codes available for validation" &&
                            episode.drg !== "No DRG"
                          ? "episodelist-td-bold-drg"
                          : "episodelist-td-normal-drg"
                      }`}
                    >
                      {/* <td className={`episodelist-td ${episode.status === "Coding Complete" ? "Coding Complete" : episode.status === "aCS Coding Complete" ? "aCS Coding Complete" : episode.status === "AI processing complete - codes available for validation" ? "episodelist-td-bold-drg" : "episodelist-td-normal-drg"}`}> */}
                      {episode.drg ? episode.drg : "-"}
                    </td>
                    <td className="episodelist-td-status">
                      <Badge
                        ref={(badge) => {
                          if (badge) {
                            badge.style.setProperty(
                              "background-color",
                              episode?.status_color,
                              "important"
                            );
                            badge.style.setProperty("display", "flex");
                            {
                              episode.status ===
                              "AI processing complete - codes available for validation"
                                ? badge.style.setProperty("color", "white")
                                : badge.style.setProperty("color", "#344054");
                            }
                            badge.style.setProperty("align-items", "center");
                            badge.style.setProperty(
                              "justify-content",
                              "center"
                            );
                            badge.style.setProperty("height", "30px");
                            badge.style.setProperty("width", "100%");
                            badge.style.setProperty("font-size", "10px");
                            badge.style.setProperty("white-space", "normal"); // Allow text to wrap
                            badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                            badge.style.setProperty(
                              "text-overflow",
                              "ellipsis"
                            ); // Add ellipsis if text overflows
                          }
                        }}
                      >
                        {episode?.status || "-"}
                      </Badge>
                    </td>
                    {location.pathname != "/Code-Assist-Episode-list" && (
                      <td className="episodelist-td">
                        {episode?.document_count > 0
                          ? episode?.document_count
                          : 0}
                      </td>
                    )}
                    {/* <td className='episodelist-td'> <Badge style={{ backgroundColor: `${episode?.status_color} !important`  || "#defaultColor !important" }}>{episode.status ? episode.status : "-"}</Badge></td> */}
                    {/* <td className='episodelist-td'>{episode.priority ? episode.priority : "N/A"}</td> */}
                  </tr>
                );
              })
            ) : (
              <td colspan="10">
                <div className="episodelist-table-loader">No Records Found</div>
              </td>
            )}
          </tbody>
        </Table>
      </div>
      <div className="episodelist-footer">
        <div>
          <Pagination size="sm" className="episodelist-pagination">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={episodeListFilterObj?.page <= 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(episodeListFilterObj?.page - 1)}
              disabled={episodeListFilterObj?.page <= 1}
              className="episodelist-prev-btn"
            />
            <Pagination.Item>
              Page {episodeListFilterObj?.page} of {totalPages}
            </Pagination.Item>

            <Pagination.Next
              onClick={() => handlePageChange(episodeListFilterObj?.page + 1)}
              disabled={episodeListFilterObj?.page >= totalPages}
              className="episodelist-next-btn"
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={episodeListFilterObj.page === totalPages}
            />
          </Pagination>
        </div>
        <div
          className="episodelist-row-options"
          style={{ marginBottom: "5px" }}
        >
          <Form.Select
            size="sm"
            className="episodelist-select"
            value={episodeListFilterObj.page_size}
            onChange={handleRowsPerPageChange}
          >
            <option value="" disabled className="episodelist-rows-per-page">
              Rows per page
            </option>
            {/* <option value={10} className="episodelist-rows-per-page">10</option> */}
            <option value={20} className="episodelist-rows-per-page">
              20
            </option>
            <option value={50} className="episodelist-rows-per-page">
              50
            </option>
            <option value={100} className="episodelist-rows-per-page">
              100
            </option>
          </Form.Select>
        </div>
      </div>
      <EpisodeListFilter
        showepisodeListFilter={showepisodeListFilter}
        setShowepisodeListFilter={setShowepisodeListFilter}
        closeEpisodeFilterModal={closeEpisodeFilterModal}
      />
    </div>
  );
};

export default EpisodeListMobile;
